import React from 'react'

import CalendarIcon from 'i/calendar.svg'
import ContactIcon from 'i/contact.svg'
import YouTubeIcon from 'i/yt.svg'

import styles from './WhyNeedAccount.module.scss'

const WhyNeedAccount = () => {
  return (
    <div className={styles.component}>
      <div className={styles.col}>
        <h3 className={styles.title}>Why only Google account?</h3>
        <div className={styles.descr}>
          To keep things seamless, Talkpro connects exclusively through your Google
          account. It lets us sync your calendar, contacts, and even your YouTube.
        </div>
      </div>
      <div className={`${styles.col} ${styles.colGoogleServices}`}>
        <div className={styles.imageWrap}>
          <img className={styles.image} src={CalendarIcon} alt="calendar" />
        </div>
        <div className={`${styles.imageWrap} ${styles.contactImageWrap}`}>
          <img className={styles.image} src={ContactIcon} alt="contact" />
        </div>
        <div className={styles.imageWrap}>
          <img className={styles.image} src={YouTubeIcon} alt="youtube" />
        </div>
      </div>
    </div>

    /*<div className={styles.component}>
      <div className={styles.col}>
        <div className={styles.imageWrap}>
          <img className={styles.image} src={MailIcon} alt="google" />
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.imageWrap}>
          <img className={styles.image} src={MailIcon2} alt="email" />
        </div>
      </div>
      <div className={styles.col}>
        <h3 className={styles.title}>Why do I need Google?</h3>
        <div className={styles.descr}>
          TalkPro is connected to all Google services to sync your calendar, youtube and
          notifications with all of your devices.
        </div>
      </div>
    </div>*/
  )
}

export default WhyNeedAccount
